import { render, staticRenderFns } from "./LatestItemsComponent.vue?vue&type=template&id=2383bbba"
import script from "./LatestItemsComponent.vue?vue&type=script&lang=js"
export * from "./LatestItemsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports